const _catalogue = [{
  name: 'Richter',
  blow: [0, 4, 7, 12, 16, 19, 24, 28, 31, 36],
  draw: [2, 7, 11, 14, 17, 21, 23, 26, 29, 33],
  comment: ''
}, {
  name: 'Country',
  blow: [0, 4, 7, 12, 16, 19, 24, 28, 31, 36],
  draw: [2, 7, 11, 14, 18, 21, 23, 26, 29, 33],
  comment: 'aka Lydian, aka Major 7th'
}, {
  name: 'Paddy richter',
  blow: [0, 4, 9, 12, 16, 19, 24, 28, 31, 36],
  draw: [2, 7, 11, 14, 17, 21, 23, 26, 29, 33],
  comment: `[Developed by Brendan Power](http://www.brendan-power.com/harmonicas-10hole.php)`
}, {
  name: 'Melodic Maker',
  blow: [-7, -3, 2, 5, 9, 12, 17, 21, 24, 29],
  draw: [-5, 0, 4, 7, 11, 14, 16, 19, 23, 26],
  comment: ''
}, {
  name: 'Natural minor',
  blow: [0, 3, 7, 12, 15, 19, 24, 27, 31, 36],
  draw: [2, 7, 10, 14, 17, 21, 22, 26, 29, 33],
  comment: ''
}, {
  name: 'Harmonic minor',
  blow: [0, 3, 7, 12, 15, 19, 24, 27, 31, 36],
  draw: [2, 7, 11, 14, 17, 20, 23, 26, 29, 32],
  comment: ''
}, {
  name: 'Circular',
  blow: [0, 4, 7, 10, 14, 17, 21, 24, 28, 31],
  draw: [2, 5, 9, 12, 16, 19, 22, 26, 29, 33],
  comment: ''
}, {
  name: 'Solo',
  blow: [0, 4, 7, 12, 12, 16, 19, 24, 24, 28, 31, 36],
  draw: [2, 5, 9, 11, 14, 17, 21, 23, 26, 29, 33, 35],
  comment: ''
}, {
  name: 'Lucky 13',
  blow: [-12, -8, -5, 0, 4, 7, 12, 16, 19, 24, 28, 31, 36],
  draw: [-10, -5, -1, 2, 7, 11, 14, 17, 21, 23, 26, 29, 33],
  comment: `[Developed by Brendan Power](http://www.brendan-power.com/lucky13.php)`
}, {
  name: 'Orchestra',
  blow: [7, 12, 12, 16, 19, 24, 24, 28, 31, 36],
  draw: [9, 11, 14, 17, 21, 23, 26, 29, 33, 35],
  comment: ''
}, {
  name: 'PowerBender',
  blow: [0, 4, 7, 12, 14, 17, 21, 24, 28, 33],
  draw: [2, 7, 11, 14, 16, 19, 23, 26, 31, 36],
  comment: `[Developed by Brendan Power](http://www.brendan-power.com/harmonicas-10hole.php)`
}, {
  name: 'PowerDraw',
  blow: [0, 4, 7, 12, 16, 19, 21, 24, 28, 33],
  draw: [2, 7, 11, 14, 17, 21, 23, 26, 31, 36],
  comment: `[Developed by Brendan Power](http://www.brendan-power.com/harmonicas-10hole.php)`
}, {
  name: 'Wholetone',
  blow: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36],
  draw: [2, 6, 10, 14, 18, 22, 26, 30, 34, 38],
  comment: `See [Some Musings On Altered Tunings For the Chromatic Harmonica](http://www.angelfire.com/music/HarpOn/patsmusings.html)`
}, {
  name: 'Diminished',
  blow: [0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33],
  draw: [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
  comment: `See [Some Musings On Altered Tunings For the Chromatic Harmonica](http://www.angelfire.com/music/HarpOn/patsmusings.html)`
}, {
  name: 'Augmented',
  blow: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36],
  draw: [3, 7, 11, 15, 19, 23, 27, 31, 35, 39],
  comment: `See [Some Musings On Altered Tunings For the Chromatic Harmonica](http://www.angelfire.com/music/HarpOn/patsmusings.html)`
}]

export function getAllTunings (cb) {
  // faking API call
  return cb(_catalogue)
}



// WEBPACK FOOTER //
// ./src/api/alteredstates.js